import React, { memo, Fragment, useState, useEffect } from "react";
import SectionSlider from "./Components/Slider/SectionSlider";
import TopTenCard from "./Components/Cards/TopTenCard";
import { useSelector } from "react-redux";

const  TopTrendingEpisodes = memo(({ data, isRegisterPage }) => {
  const [title, setTitle] = useState("");
  const [shows, setShows] = useState([]);
  let count = 0;
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  useEffect(() => {
    setShows(data?.shows)
    setTitle(data?.category_name)
   
  }, [data]);
  const thumbnail = data?.thumbnail_orientation ? data?.thumbnail_orientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;
  const isFreeMovies = Number(projectInfo?.projectConfig?.pubid) === 50188;
  const visibleItemsCount = Number(data?.visible_items_count)
    || Number(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT)
    || (thumbnail === "PORTRAIT" ? 8 : 4);

  useEffect(() => {
    const trendingShows = Array.isArray(data?.shows) ? data.shows : [];
    let preloadIndex = visibleItemsCount;
    let cancelled = false;
    let preloadTimer;

    const preloadNextImage = () => {
      if (cancelled || preloadIndex >= trendingShows.length) return;

      const show = trendingShows[preloadIndex];
      const imagePath = thumbnail === "PORTRAIT" ? show?.logo : show?.logo_thumb;
      preloadIndex += 1;

      if (!imagePath) {
        preloadNextImage();
        return;
      }

      const image = new Image();
      const continuePreloading = () => {
        if (!cancelled) preloadNextImage();
      };
      image.onload = continuePreloading;
      image.onerror = continuePreloading;
      image.src = imagePath;
    };

    preloadTimer = setTimeout(preloadNextImage, 1000);

    return () => {
      cancelled = true;
      clearTimeout(preloadTimer);
    };
  }, [data, thumbnail, visibleItemsCount]);

  return (
    <Fragment>  
    {thumbnail=== "PORTRAIT" ? <SectionSlider title={title} list={shows} className={`top-ten-block ${isFreeMovies ? "top-ten-free-movies" : ""}`} data={data} thumbnail={thumbnail} slidesPerView={5} visibleItemsCount={data?.visible_items_count} isRegisterPage={isRegisterPage} hideMobileNavigation role="region" aria-label="Top Trending Episodes Portrait Section">
      {(shows, index) => {
        const link = shows?.video_id ?(`/videos/${shows?.vanity_url}`):(`/show-details/${shows?.vanity_url}`);   
        count += 1;
        return (
          <TopTenCard
            imagePath={shows.logo}
            countValue={count}
            link={link}
            state={{ videoDetails:shows }}
            thumbnail={thumbnail}
            isRegisterPage={isRegisterPage}
            cardIndex={index}
            initialVisibleCount={visibleItemsCount}
          />
        )
      }}
    </SectionSlider>
    :
    <SectionSlider title={title} list={shows} className={`top-ten-block ${isFreeMovies ? "top-ten-free-movies" : ""}`} data={data} slidesPerView={5} visibleItemsCount={data?.visible_items_count} styleElement={false} thumbnail={thumbnail} isRegisterPage={isRegisterPage} hideMobileNavigation role="region" aria-label="Top Trending Episodes Landscape Section">
      {(shows, index) => {
        const link = shows?.video_id ?(`/videos/${shows?.vanity_url}`):(`/show-details/${shows?.vanity_url}`);   
        count += 1;
        return (
          <TopTenCard
            imagePath={shows.logo_thumb}
            portraitImagePath={isRegisterPage ? shows.logo : undefined}
            countValue={count}
            link={link}
            state={{ videoDetails:shows }}
            isRegisterPage={isRegisterPage}
            cardIndex={index}
            initialVisibleCount={visibleItemsCount}
          />
        )
      }}
    </SectionSlider>
    }
  </Fragment>
  );
});

TopTrendingEpisodes.displayName = " TopTrendingEpisodes";
export default  TopTrendingEpisodes;

